import React from "react"
import styled from "@emotion/styled"

const Outer = styled.div`
  grid-column: span 3;
  display: grid;
  background: ${props => props.theme.primary};
  grid-template-columns:
    minmax(24px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(24px, auto);
  width: 100%;
  padding: 32px;
  @media (max-width: ${props => props.theme.breakpoints.lg}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Content = styled.div`
  color: ${props => props.textColor};
  padding: 0 0;
  grid-column: 2 / 3;
  max-width: ${props => props.theme.maxWidth};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 32px;
  justify-content: center;
  align-items: center;
  @media (max-width: ${props => props.theme.breakpoints.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`

export default function CountUp(props) {
  return (
    <Outer data-sal="fade" data-sal-duration="600">
      <Content>{props.children}</Content>
    </Outer>
  )
}
